var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('static-content-wrapper', {
    attrs: {
      "designer": _vm.designer,
      "field": _vm.field,
      "design-state": _vm.designState,
      "parent-widget": _vm.parentWidget,
      "parent-list": _vm.parentList,
      "index-of-parent-list": _vm.indexOfParentList,
      "sub-form-row-index": _vm.subFormRowIndex,
      "sub-form-col-index": _vm.subFormColIndex,
      "sub-form-row-id": _vm.subFormRowId
    }
  }, [_c('div', {
    class: [!!_vm.designState ? 'slot-wrapper-design' : 'slot-wrapper-render']
  }, [_vm._t(_vm.field.options.name, null, {
    "formModel": _vm.formModel
  }), _vm._v(" "), (!!_vm.designState) ? _c('div', {
    staticClass: "slot-title"
  }, [_vm._v(_vm._s(_vm.field.options.label))]) : _vm._e()], 2)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6caaa7a5","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/form-widget/field-widget/slot-widget.vue
// module id = null
// module chunks = 